<template>
  <div id="app">
    <router-view v-if="isRouterAlive"/>
  </div>
</template>

<script>
export default {
  name: "App",
  provide () {
    // 父组件中通过provide来提供变量，在子组件中通过inject来注入变量。
    return {
      reload: this.reload
    }
  },
  data () {
    return {
      isRouterAlive: true // 控制视图是否显示的变量
    }
  },
  methods: {
    reload () {
      this.isRouterAlive = false // 先关闭，
      this.$nextTick(function () {
        this.isRouterAlive = true // 再打开
      })
    }
  },
}
</script>

<style>
html,body,#app{
  height: 100%;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
body,
h2,
h3,
h4,
p,
ul {
  margin: 0;
}
.banner-imgs .el-carousel__container {
  height: 100% !important;
}
.banner-imgs .el-carousel__container img {
  object-fit: cover;
}
/* 去除头部底下多余的margin */
.header-bottom.el-divider {
  margin-top: 0;
}
.clear-bottom.el-divider {
  margin-bottom: 0;
}
/* 去除tabs底部的横线 */
.el-tabs__nav-wrap::after {
  height: 0 !important;
  display: none;
}
.el-tabs__item {
  padding: 0 16px !important;
}
/* .el-tabs_nav-scroll{
  text-align: right;
}
.el-tabs_nav-scroll .el-tabs_nav{
  width:100%;
} */
/* 搜索框后面的button字居中 */
.el-input-group__append {
  padding: 0;
  width: 15%;
}
.el-select-dropdown .el-scrollbar li {
  display: block;
}
.search-item .el-input-group__prepend,
.search-bar .el-input-group__prepend {
  width: 100px;
}
/*修改上传图片input默认样式*/
.file {
  position: relative;
  display: inline-block;
  overflow: hidden;
}
.file img {
  width: 132px;
  height: 126px;
}
.file input {
  width: 132px;
  height: 126px;
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  opacity: 0;
}
.file .input-div {
  position: relative;
  display: inline-block;
  width: 132px;
  height: 126px;
  background-size: 100%;
  border: 1px dashed #e4e4e4;
}
.upload h2 {
  margin: 30px 0 20px;
  font-size: 16px;
  font-weight: 400;
}
.upload img {
  width: 132px;
  height: 126px;
  margin-right: 5px;
}
/*修改上传图片input默认样式*/
/* 房源列表，租金一栏input样式修改 */
.custom-item .el-input .el-input__inner {
  height: 100%;
  padding: 0;
  margin: 0;
}
/* 分页居中显示 */
.el-pagination {
  text-align: center;
}
.el-input-group__append .company-search.el-button {
  text-align: center;
}
.el-input-group__append {
  text-align: center;
}
.el-button,
.pointer {
  cursor: pointer;
}
.el-carousel__container .el-carousel__arrow:hover {
  background-color: rgba(31, 45, 61, 0.6);
}
.boxxx .el-message-box__message p::before{
    content: '* ';
    color: red;
}
</style>
